module.exports = __webpack_public_path__ + "img/DC-star-blue.b8f3873c.svg";